<template>
  <a-card class="content " :bordered="false">
    <h6 class="m-b-25 s_font_b s_fonts18">数据概况</h6>
    <div class="m-t-20 s_flex_bian_c"> 
      <div class=" flex_1 s_FBFCFC m-r-140 m-l-40 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">会员总数</h4>
        <div class="m-t-20 s_font_b s_fonts30">{{memberData.total}}</div>
      </div>
      <div class="flex_1 s_FBFCFC m-r-140 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">昨日新增会员</h4>
        <div class="m-t-20 s_font_b s_fonts30">{{memberData.new}}</div>
      </div>
      <div class="flex_1 s_FBFCFC m-r-40 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">昨日访问人数</h4>
        <div class="m-t-20 s_font_b s_fonts30">{{memberData.access}}</div>
      </div>
    </div>
    <div class="m-t-60 s_po_re" style="min-height:420px">
      <div class=" s_over_h p-r-40 ">
        <div class="fr s_flex_ali s_bor3 s_over_h">
          <div class="day_active"  :class="{ active: active == 7 }"  @click="changeTime(7)"> 近7天</div>
          <div class="day_active" :class="{ active: active == 30 }" @click="changeTime(30)">近30天</div>
        </div>
      </div>
      <a-spin tip="Loading..."  :spinning="Loading">
         <lineChart ref="myChart" v-show="!Loading"></lineChart>
         <barChart ref="myBar" v-show="!Loading"></barChart>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import lineChart from "./components/lineChart.vue";
import barChart from './components/barChart.vue'
import {memberGeneral} from '@/api/member.js'
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
export default {
  components: {
    lineChart,
    barChart
  },
  setup() {
    const myChart = ref(null);
    const myBar = ref(null);
    const state = reactive({
      active: 7,
      echartDate: {
        data1: [],
        dataName: "新增数",
        date: [],
      },
      barDate:{
        data1:[],
        data2:[]
      },
      memberData:{},
      Loading:false
    });

    const changeTime = function (val) {
      state.active = val;
      getMemberGeneral(val)
    }

    //获取数据
    const getMemberGeneral = async function(value){
        state.Loading = true;
        let res = await memberGeneral({days:value}).then(res=>res.data);
        if(iscode(res)){
           state.memberData = res.data || {};
           state.echartDate.data1 =[];
           state.echartDate.date = [];
           state.barDate.data1 = [];
           state.barDate.data2 = [];
           let staticArr = res.data.static || [];
           let areaArr = res.data.area || [];
           if(staticArr.length!=0){
              staticArr.forEach((v,i)=>{
               state.echartDate.data1.push(v.new_members)
               state.echartDate.date.push(v.date)
              })
           }
           if(areaArr.length!=0){
              areaArr.forEach((v,i)=>{
                state.barDate.data1.push(v.area_name);
                 state.barDate.data2.push(v.total)
              })
           }
           
           myChart.value.renderEcharts(state.echartDate); //折线图
           myBar.value.renderEchart(state.barDate); //柱状图
           state.Loading = false;
        }else{
          state.Loading = false;
           message.error(res.msg)
        }
    }

   

    onMounted(() => {
      getMemberGeneral('7')
    });
    return {
      ...toRefs(state),
      myChart,
      changeTime,
      myBar
    };
  },
};
</script>

<style lang="less" scoped>
.day_active {
  width: 100px;
  height: 40px;
  background: #fff;
  color: #333;
  border: 1px solid #cecece;
  text-align: center;
  line-height: 40px;
  // margin-left: -1px;
  cursor: pointer;
}
.active {
  background: #143960;
  color: #fff;
  border: none;
  cursor: pointer;
}
.item{
  box-shadow:6px 8px 20px 0 rgba(0,0,0,.3);
  // inset -3px -2px 7px 0 rgb(0 0 0 / 30%)
  border-radius: 10px;
}
</style>
